module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./src/index.ts":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__("react");
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__("prop-types");
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__("styled-components");
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/styles/index.js

var ContentShellWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentShellWrapper",
  componentId: "u3vgnb-0"
})(["width:100%;"]);
var ContentWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentWrapper",
  componentId: "u3vgnb-1"
})(["width:100%;padding:48px 0px;margin:0;box-sizing:border-box;background-color:black;position:relative;display:flex;flex-flow:column;min-height:1px;@media (min-width:", "px){padding:50px 12px;}@media (min-width:", "px){padding:0px 32px;min-height:640px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentTextWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentTextWrapper",
  componentId: "u3vgnb-2"
})(["order:1;@media (min-width:", "px){padding-left:80px;}"], function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentImageLazyLoadWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentImageLazyLoadWrapper",
  componentId: "u3vgnb-3"
})(["position:relative;order:2;margin-left:auto;margin-right:auto;max-width:100%;min-width:1px;@media (min-width:", "px){height:auto;top:0px;right:0px;position:absolute;}"], function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentImage = external_styled_components_default.a.img.withConfig({
  displayName: "ContentImage",
  componentId: "u3vgnb-4"
})(["min-width:1px;@media (max-width:", "px){margin:1em;}@media (min-width:", "px){height:auto;top:0px;right:0px;position:absolute;}"], function (props) {
  return props.theme.breakpoints.values.lg;
}, function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentYellowBarBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentYellowBarBase",
  componentId: "u3vgnb-5"
})(["width:30px;height:4px;color:#ffffff;background-color:#fbb649;"]);
var ContentYellowBar = external_styled_components_default()(ContentYellowBarBase).withConfig({
  displayName: "ContentYellowBar",
  componentId: "u3vgnb-6"
})(["margin-left:auto;margin-right:auto;@media (min-width:", "px){position:absolute;top:135px;left:80px;}"], function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentReadMoreYellowBar = external_styled_components_default()(ContentYellowBarBase).withConfig({
  displayName: "ContentReadMoreYellowBar",
  componentId: "u3vgnb-7"
})(["margin-left:auto;margin-right:auto;@media (min-width:", "px){margin-left:0px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentImageHeader = external_styled_components_default.a.span.withConfig({
  displayName: "ContentImageHeader",
  componentId: "u3vgnb-8"
})(["width:auto;color:#ffffff;font-family:'Brandon Text';font-size:24px;font-weight:700;line-height:28px;text-transform:uppercase;text-align:center;margin-left:auto;margin-right:auto;padding-top:22px;margin-bottom:0px;display:block;@media (min-width:", "px){font-size:38px;line-height:38px;text-align:left;position:absolute;top:158px;left:81px;padding-top:0px;}"], function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentImageHeader2 = external_styled_components_default.a.h2.withConfig({
  displayName: "ContentImageHeader2",
  componentId: "u3vgnb-9"
})(["color:#ffffff;font-family:'Brandon Text';font-size:24px;font-weight:700;line-height:28px;text-transform:uppercase;text-align:center;margin-left:auto;margin-right:auto;width:auto;margin-bottom:0px;@media (min-width:", "px){font-size:38px;line-height:38px;text-align:left;position:absolute;top:196px;left:81px;}"], function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentText = external_styled_components_default.a.div.withConfig({
  displayName: "ContentText",
  componentId: "u3vgnb-10"
})(["color:#ffffff;font-family:'Brandon Text';font-weight:400;line-height:18px;letter-spacing:0.35px;text-align:center;font-size:14px;margin-top:25px;width:20em;margin-right:auto;margin-left:auto;cursor:pointer;@media (min-width:", "px){letter-spacing:0.4px;width:30em;font-size:16px;margin-left:auto;margin-right:auto;line-height:24px;}@media (min-width:", "px){letter-spacing:0.45px;text-align:left;position:absolute;top:249px;left:81px;width:360px;font-size:18px;line-height:24px;margin-top:auto;text-shadow:2px 1px 0px #222;}"], function (props) {
  return props.theme.breakpoints.values.sm;
}, function (props) {
  return props.theme.breakpoints.values.lg;
});
var ContentTextReadMore = external_styled_components_default.a.span.withConfig({
  displayName: "ContentTextReadMore",
  componentId: "u3vgnb-11"
})(["text-decoration:underline;"]);
var ContentReadMoreAreaWrapper = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReadMoreAreaWrapper",
  componentId: "u3vgnb-12"
})(["background-color:white;padding:16px 0px 32px;text-align:center;"]);
var ContentReadMoreSections = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReadMoreSections",
  componentId: "u3vgnb-13"
})(["display:flex;flex-flow:column;width:90%;text-align:center;margin-left:auto;margin-right:auto;@media (min-width:", "px){width:75%;display:inline-block;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReadMoreSectionBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReadMoreSectionBase",
  componentId: "u3vgnb-14"
})(["background-color:white;padding:19px 0px;order:1;position:relative;vertical-align:top;& p span{display:block;height:18px;color:#183558;font-family:'Brandon Text';font-size:24px;font-weight:700;line-height:26px;text-transform:uppercase;margin-top:19px;padding-bottom:1em;}& p{color:#757989;font-family:'Brandon Text';font-size:22px;font-weight:300;}"]);
var ContentReadMoreOverview = external_styled_components_default()(ContentReadMoreSectionBase).withConfig({
  displayName: "ContentReadMoreOverview",
  componentId: "u3vgnb-15"
})(["order:1;@media (min-width:", "px){text-align:left;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReadMoreSectionBottom = external_styled_components_default()(ContentReadMoreSectionBase).withConfig({
  displayName: "ContentReadMoreSectionBottom",
  componentId: "u3vgnb-16"
})(["padding-bottom:0px;& h3{font-family:'Brandon Text';color:#183558;font-size:18px;font-weight:700;text-transform:uppercase;margin-top:19px;}@media (min-width:", "px){width:50%;text-align:left;display:inline-block;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReadMoreSectionTwo = external_styled_components_default()(ContentReadMoreSectionBottom).withConfig({
  displayName: "ContentReadMoreSectionTwo",
  componentId: "u3vgnb-17"
})(["order:3;"]);
var ContentReadMoreSectionThree = external_styled_components_default()(ContentReadMoreSectionBottom).withConfig({
  displayName: "ContentReadMoreSectionThree",
  componentId: "u3vgnb-18"
})(["order:5;"]);
var ContentReadMoreSectionSeparatorBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentReadMoreSectionSeparatorBase",
  componentId: "u3vgnb-19"
})(["height:1px;background-color:#d9dde9;width:100%;margin-top:30px;margin-bottom:35px;@media (min-width:", "px){display:none;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentReadMoreSectionSeparatorTwo = external_styled_components_default()(ContentReadMoreSectionSeparatorBase).withConfig({
  displayName: "ContentReadMoreSectionSeparatorTwo",
  componentId: "u3vgnb-20"
})(["order:2;"]);
var ContentReadMoreSectionSeparatorFour = external_styled_components_default()(ContentReadMoreSectionSeparatorBase).withConfig({
  displayName: "ContentReadMoreSectionSeparatorFour",
  componentId: "u3vgnb-21"
})(["order:4;"]);
var ContentSectionTextBase = external_styled_components_default.a.div.withConfig({
  displayName: "ContentSectionTextBase",
  componentId: "u3vgnb-22"
})(["font-family:'Brandon Text';font-size:14px;font-weight:400;line-height:20px;width:90%;margin-left:auto;margin-right:auto;color:#757989;text-align:left;@media (min-width:", "px){font-size:18px;line-height:24px;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentSectionOverviewText = external_styled_components_default()(ContentSectionTextBase).withConfig({
  displayName: "ContentSectionOverviewText",
  componentId: "u3vgnb-23"
})(["@media (min-width:", "px){margin-left:0px;width:100%;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
var ContentSectionTextBottom = external_styled_components_default()(ContentSectionTextBase).withConfig({
  displayName: "ContentSectionTextBottom",
  componentId: "u3vgnb-24"
})(["& h3{color:#757989;font-weight:700;text-decoration:underline;margin-top:19px;}@media (min-width:", "px){margin-left:0px;width:85%;}"], function (props) {
  return props.theme.breakpoints.values.sm;
});
// EXTERNAL MODULE: external "@carvana/theme"
var theme_ = __webpack_require__("@carvana/theme");

// CONCATENATED MODULE: ./src/helpers/index.js
var multiple = function multiple(factor) {
  return function (size) {
    return {
      height: size.height * factor,
      width: size.width * factor
    };
  };
};
var helpers_double = multiple(2);
var triple = multiple(3);
var contentImage = function contentImage(ext) {
  return function (imageName) {
    return function (assetsUrl) {
      return assetsUrl + "/traffic-assets/content-mods/" + imageName + "." + ext;
    };
  };
};
var contentJpg = contentImage('jpg');
var contentPng = contentImage('png');
var getSrcSet = function getSrcSet(sizeList) {
  return function (ext) {
    return function (imageURL) {
      return function (assetsUrl) {
        return sizeList.reduce(function (p, c) {
          return (p ? p + "," : '') + " " + contentImage(ext)(imageURL + "." + c.width + "x" + c.height)(assetsUrl) + " " + c.scale;
        }, '');
      };
    };
  };
};
var sortSectionPriority = function sortSectionPriority(a, b) {
  return a.sectionPriority - b.sectionPriority;
};
// CONCATENATED MODULE: ./src/static/index.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }


var sizes = {
  small: {
    height: 160,
    width: 262
  },
  medium: {
    height: 320,
    width: 524
  },
  large: {
    height: 640,
    width: 1048
  }
};
var sizeList = {
  small: [// small mobile image
  _extends({}, sizes.small, {
    scale: '1x'
  }), _extends({}, helpers_double(sizes.small), {
    scale: '2x'
  }), _extends({}, triple(sizes.small), {
    scale: '3x'
  })],
  medium: [// tablet image
  _extends({}, sizes.medium, {
    scale: '1x'
  }), _extends({}, helpers_double(sizes.medium), {
    scale: '2x'
  }), _extends({}, triple(sizes.medium), {
    scale: '3x'
  })],
  large: [// desktop image
  _extends({}, sizes.large, {
    scale: '1x'
  }), _extends({}, helpers_double(sizes.large), {
    scale: '2x'
  }), _extends({}, triple(sizes.large), {
    scale: '3x'
  })]
};
var static_trackEvent = function trackEvent(eventString, eventObject) {
  console.log('Tracked Click Event', eventString, eventObject);
};
var content = {
  contentMod: {
    id: 3240,
    urlPath: '/cars',
    imageHeader1: 'Carvana',
    imageHeader2: 'Used Cars Guide',
    imageUrl: 'jeep-nobranding',
    imageText: 'Get the best online car shopping experience with expert reviews of Used Cars. Read more to learn about the most important features and important factors to consider when researching Used Cars.',
    imageAltText: 'Used Cars Car Guide',
    overviewHeader1: 'Overview',
    overviewHeader2: 'USED CARS',
    overviewText: "One of the first considerations you take as a car buyer is deciding whether to look for a used car or a new car. It's no secret that many new cars lose nearly half their value in the first three years after they're sold. Used cars can save you a lot of money upfront and over the long term, as you won't be paying as much interest. A common thought is that used cars are less reliable, but modern vehicles are more reliable than ever, and many brands have more consumer trust than ever before.",
    imageURL: 'jeep-nobranding'
  },
  contentModsSections: [{
    sectionPriority: 1,
    sectionHeader: 'NOTEWORTHY FEATURES',
    subSections: [{
      sectionPriority: 1,
      sectionHeader: 'Less Depreciation',
      sectionText: "New cars depreciate at around 20% as soon as you drive them off the lot. In the following year, most cars lose up to an additional 10% of their value. By year three, many cars have lost nearly half their original value. Buying a used car that's two or three years old means that someone else took the depreciation hit. The most cost-effective way to buy and own a car is to buy a lightly used car after the largest depreciation, and then drive it for as long as you can."
    }, {
      sectionPriority: 2,
      sectionHeader: 'Stretch Your Dollar',
      sectionText: 'Buying a used car at least two or three years older than the current model year can stretch your car-buying dollar by allowing you to move up in trims and options for less. For example, if you spend $30,000 on a new car, that might only get you the base trim in some models. However, if that same vehicle is three years old, you might get the top or near the top trim for the same amount.'
    }, {
      sectionPriority: 3,
      sectionHeader: 'Reliability',
      sectionText: "New cars, especially redesigned models, don't have any reliability history. There's a reason why recalls often happen within the first year a vehicle is released. If you buy a used car, then you'll easily be able to find what problems to avoid and what models have them."
    }]
  }, {
    sectionPriority: 2,
    sectionHeader: 'ADDITIONAL CONSIDERATIONS',
    subSections: [{
      sectionPriority: 1,
      sectionHeader: 'Flexibility',
      sectionText: "When you buy a used car instead of a new one, it's important to be flexible about what you want and what's most important. With a new car, you can customize nearly everything about it. With a used car, you may have to choose a different color or trim level in order to get better mileage numbers or a cleaner history. You might also have to consider a different model entirely if the model you're looking for is hard to find with the options you want."
    }, {
      sectionPriority: 2,
      sectionHeader: 'Safety Features',
      sectionText: 'Safety technology evolves and develops quickly, which means that new features become available with nearly every model year. Buying used can sometimes make it more difficult to get the latest technology.'
    }, {
      sectionPriority: 3,
      sectionHeader: 'Fuel Economy',
      sectionText: "Like with safety features, newer cars tend to get more fuel-efficient as technology improves. It's important to consider the age of the vehicle, the fuel economy, and the discount you can earn when buying it used before actually making a decision."
    }]
  }]
};
// CONCATENATED MODULE: ./src/ContentPicture.tsx






var ContentPicture_ContentPicture = function ContentPicture(_ref) {
  var mods = _ref.contentMods,
      isVisible = _ref.isVisible,
      assetsUrl = _ref.assetsUrl;

  var smallSrcSet = function smallSrcSet(ext) {
    return function (url) {
      return getSrcSet(sizeList.small)(ext)(url);
    };
  };

  var mediumSrcSet = function mediumSrcSet(ext) {
    return function (url) {
      return getSrcSet(sizeList.medium)(ext)(url);
    };
  };

  var largeSrcSet = function largeSrcSet(ext) {
    return function (url) {
      return getSrcSet(sizeList.large)(ext)(url);
    };
  };

  return !isVisible ? null : /*#__PURE__*/external_react_default.a.createElement("picture", null, /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.lg + "px )",
    type: "image/webp",
    srcSet: largeSrcSet('webp')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.lg + "px )",
    type: "image/jp2",
    srcSet: largeSrcSet('jp2')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.lg + "px )",
    type: "image/jxr",
    srcSet: largeSrcSet('jxr')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.lg + "px )",
    type: "image/jpg",
    srcSet: largeSrcSet('jpg')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.sm + "px )",
    type: "image/webp",
    srcSet: mediumSrcSet('webp')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.sm + "px )",
    type: "image/jp2",
    srcSet: mediumSrcSet('jp2')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.sm + "px )",
    type: "image/jxr",
    srcSet: mediumSrcSet('jxr')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: " + theme_["CarvanaTheme"].breakpoints.values.sm + "px )",
    type: "image/jpg",
    srcSet: mediumSrcSet('jpg')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: 0px )",
    type: "image/webp",
    srcSet: smallSrcSet('webp')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: 0px )",
    type: "image/jp2",
    srcSet: smallSrcSet('jp2')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: 0px )",
    type: "image/jxr",
    srcSet: smallSrcSet('jxr')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement("source", {
    media: "(min-width: 0px )",
    type: "image/jpg",
    srcSet: smallSrcSet('jpg')(mods.contentMod.imageURL)(assetsUrl)
  }), /*#__PURE__*/external_react_default.a.createElement(ContentImage, {
    "data-cv-test": "Cv.Search.ContentMods.ContentImage",
    src: contentJpg(mods.contentMod.imageURL + ".1048x640")(assetsUrl),
    alt: mods.contentMod.imageAltText
  }));
};
ContentPicture_ContentPicture.defaultProps = {
  isVisible: false
};
ContentPicture_ContentPicture.propTypes = {
  contentMods: external_prop_types_default.a.shape({}).isRequired,
  isVisible: external_prop_types_default.a.bool
};
/* harmony default export */ var src_ContentPicture = (ContentPicture_ContentPicture);
// CONCATENATED MODULE: ./src/IntersectionObserverWrapper.tsx



var IntersectionObserverWrapper_IntersectionObserverWrapper = function IntersectionObserverWrapper(_ref) {
  var options = _ref.options,
      callBack = _ref.callBack,
      autoDisconnect = _ref.autoDisconnect,
      children = _ref.children;

  var _useState = Object(external_react_["useState"])(false),
      isVisible = _useState[0],
      setIsVisible = _useState[1];

  var intersectionObserver; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var container = Object(external_react_["useRef"])();

  var handleObservations = function handleObservations(entries) {
    var entry = entries[0];

    if (entry.intersectionRatio > 0) {
      setIsVisible(entry.isIntersecting);
      callBack();

      if (autoDisconnect) {
        intersectionObserver.disconnect();
      }
    }
  };

  Object(external_react_["useEffect"])(function () {
    intersectionObserver = new IntersectionObserver(function (entries) {
      return handleObservations(entries);
    }, options);
    intersectionObserver.observe(container.current);
  }, []);
  return /*#__PURE__*/external_react_default.a.createElement("div", {
    ref: container
  }, Array.isArray(children) ? children.map(function (child) {
    return child(isVisible);
  }) : children(isVisible));
};

IntersectionObserverWrapper_IntersectionObserverWrapper.propTypes = {
  children: external_prop_types_default.a.func.isRequired,
  callBack: external_prop_types_default.a.func,
  options: external_prop_types_default.a.shape({}),
  autoDisconnect: external_prop_types_default.a.bool
};
IntersectionObserverWrapper_IntersectionObserverWrapper.defaultProps = {
  callBack: function callBack() {},
  options: {
    root: null,
    rootMargin: '0px 0px 0px 0px',
    threshold: [0, 1]
  },
  autoDisconnect: true
};
/* harmony default export */ var src_IntersectionObserverWrapper = (IntersectionObserverWrapper_IntersectionObserverWrapper);
// CONCATENATED MODULE: ./src/ContentMod.tsx






var ContentMod_Content = function Content(_ref) {
  var mods = _ref.contentMods,
      assetsUrl = _ref.assetsUrl,
      trackEvent = _ref.trackEvent;
  var isLoading = mods.isLoading,
      isError = mods.isError; // eslint-disable-next-line @typescript-eslint/no-explicit-any

  var readMoreAreaRef = Object(external_react_["useRef"])();

  var onReadMoreClick = function onReadMoreClick() {
    if (readMoreAreaRef && readMoreAreaRef.current.scrollIntoView) {
      if (trackEvent) {
        trackEvent('ContentMods: Clicked Read More', {
          googleanalytics: {
            eventCategory: 'ContentMods',
            eventAction: 'click',
            eventLabel: 'Read More'
          }
        }, ['kissmetrics', 'googleanalytics']);
      }

      readMoreAreaRef.current.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      });
    }
  };

  var mapSubsections = function mapSubsections(subSection) {
    return /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, {
      key: subSection.sectionHeader
    }, /*#__PURE__*/external_react_default.a.createElement("h3", null, subSection.sectionHeader), /*#__PURE__*/external_react_default.a.createElement("span", null, subSection.sectionText));
  };

  var orderedSections = mods.contentModsSections.sort(sortSectionPriority);
  var doSectionsExist = orderedSections && orderedSections.length === 2;
  var firstSection = doSectionsExist && orderedSections[0];
  var secondSection = doSectionsExist && orderedSections[1];
  var firstSubSections = doSectionsExist && orderedSections[0].subSections.sort(sortSectionPriority);
  var secondSubSections = doSectionsExist && orderedSections[1].subSections.sort(sortSectionPriority);
  var firstSubSectionsList = doSectionsExist && firstSubSections.map(mapSubsections);
  var secondSubSectionsList = doSectionsExist && secondSubSections.map(mapSubsections);
  var contentModExists = mods && mods.contentMod && doSectionsExist;
  var imageText = contentModExists && mods.contentMod.imageText || '';

  var _imageText$split = imageText.split('Read more'),
      imageTextFirst = _imageText$split[0],
      imageTextLast = _imageText$split[1];

  var doRenderNothing = isError || !contentModExists || isLoading;
  return doRenderNothing ? null : /*#__PURE__*/external_react_default.a.createElement(ContentShellWrapper, null, /*#__PURE__*/external_react_default.a.createElement(ContentWrapper, null, /*#__PURE__*/external_react_default.a.createElement(ContentImageLazyLoadWrapper, null, /*#__PURE__*/external_react_default.a.createElement(src_IntersectionObserverWrapper, null, function (isVisible) {
    return /*#__PURE__*/external_react_default.a.createElement(src_ContentPicture, {
      contentMods: mods,
      isVisible: isVisible,
      assetsUrl: assetsUrl
    });
  })), /*#__PURE__*/external_react_default.a.createElement(ContentTextWrapper, null, /*#__PURE__*/external_react_default.a.createElement(ContentYellowBar, null), /*#__PURE__*/external_react_default.a.createElement(ContentImageHeader, {
    "data-cv-test": "Cv.Search.ContentMods.ImageHeader1"
  }, mods.contentMod.imageHeader1), /*#__PURE__*/external_react_default.a.createElement(ContentImageHeader2, {
    "data-cv-test": "Cv.Search.ContentMods.ImageHeader2"
  }, mods.contentMod.imageHeader2), /*#__PURE__*/external_react_default.a.createElement(ContentText, {
    "data-cv-test": "Cv.Search.ContentMods.ImageText",
    onClick: function onClick() {
      return onReadMoreClick();
    }
  }, imageTextFirst, /*#__PURE__*/external_react_default.a.createElement(ContentTextReadMore, null, "Read more"), imageTextLast)), /*#__PURE__*/external_react_default.a.createElement("div", {
    ref: readMoreAreaRef,
    style: {
      position: 'absolute',
      height: '68px',
      bottom: '0px'
    }
  }, /*#__PURE__*/external_react_default.a.createElement("span", null))), /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreAreaWrapper, {
    "data-cv-test": "Cv.Search.ContentMods.ReadMoreAreaWrapper"
  }, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreSections, {
    "data-cv-test": "Cv.Search.ContentMods.ReadMoreSections"
  }, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreOverview, {
    "data-cv-test": "Cv.Search.ContentMods.Overview"
  }, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreYellowBar, null), /*#__PURE__*/external_react_default.a.createElement("p", {
    "data-cv-test": "Cv.Search.ContentMods.OverviewHeader2"
  }, /*#__PURE__*/external_react_default.a.createElement("span", {
    "data-cv-test": "Cv.Search.ContentMods.OverviewHeader1"
  }, mods.contentMod.overviewHeader1), mods.contentMod.overviewHeader2), /*#__PURE__*/external_react_default.a.createElement(ContentSectionOverviewText, {
    "data-cv-test": "Cv.Search.ContentMods.OverviewText"
  }, mods.contentMod.overviewText)), !doSectionsExist ? null : /*#__PURE__*/external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreSectionSeparatorTwo, null), /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreSectionTwo, {
    "data-cv-test": "Cv.Search.ContentMods.SectionTwo"
  }, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreYellowBar, null), /*#__PURE__*/external_react_default.a.createElement("h3", {
    "data-cv-test": "Cv.Search.ContentMods.SectionTwoHeader"
  }, firstSection.sectionHeader), /*#__PURE__*/external_react_default.a.createElement(ContentSectionTextBottom, {
    "data-cv-test": "Cv.Search.ContentMods.SectionTwoTextBottom"
  }, firstSubSectionsList)), /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreSectionSeparatorFour, null), /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreSectionThree, {
    "data-cv-test": "Cv.Search.ContentMods.SectionThree"
  }, /*#__PURE__*/external_react_default.a.createElement(ContentReadMoreYellowBar, null), /*#__PURE__*/external_react_default.a.createElement("h3", {
    "data-cv-test": "Cv.Search.ContentMods.SectionThreeHeader"
  }, secondSection.sectionHeader), /*#__PURE__*/external_react_default.a.createElement(ContentSectionTextBottom, {
    "data-cv-test": "Cv.Search.ContentMods.SectionThreeTextBottom"
  }, secondSubSectionsList))))));
};
ContentMod_Content.defaultProps = {
  trackEvent: null
};
ContentMod_Content.propTypes = {
  contentMods: external_prop_types_default.a.shape({}).isRequired,
  assetsUrl: external_prop_types_default.a.string.isRequired,
  trackEvent: external_prop_types_default.a.func
};
/* harmony default export */ var ContentMod = (ContentMod_Content);
// CONCATENATED MODULE: ./src/index.ts

/* harmony default export */ var src = __webpack_exports__["default"] = (ContentMod);

/***/ }),

/***/ "@carvana/theme":
/***/ (function(module, exports) {

module.exports = require("@carvana/theme");

/***/ }),

/***/ "prop-types":
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ "react":
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ "styled-components":
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ })

/******/ });
//# sourceMappingURL=index.js.map